import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, output } from '@angular/core';

/**
 * An active filter that has no select of its own (an extra added through
 * "Add filter", a folder picked in the tree). Shows "Label: value" and a
 * remove button named after the filter.
 */
@Component({
  selector: 'app-filter-chip-cabinet',
  templateUrl: './filter-chip.component.html',
  styleUrl: './filter-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class FilterChipCabinetComponent {
  readonly label = input.required<string>();
  readonly value = input<string>('');
  readonly remove = output<void>();

  readonly removeLabel = computed(() => `Remove filter: ${this.label()}`);
}
